import moment from 'moment';

export const initialPatientsState = {
    patient: {
        id: null,
        surname: null,
        forename: null,
        birth_date: null,
        gender: null,
        race: null,
        address: null,
        nhs_id: null,
        post_code: null,
        second_address: null,
        country: null,
        county: null,
        is_registered: false,
        town: null,
        pharmacy_site_id: null,
        consultant_id: null,
        collection_centre_id: null,
        first_blood_sample_date: null,
        last_blood_sample_date: null,
        next_due_date: null,
        blood_testing_frequency: null,
        status: false,
        dont_send_mails: false,
        health_information: {
            cnrd_date: null,
            up_to_including_date: null,
            normal_blood_sample_day: null,
            is_checked: false,
            cnrd_entry_found: false,
            is_locked: false,
            is_with_ben: false,
            past_history_of_neutropenia: false,
        },
        diagnosis: {
            diagnosis: null,
            is_prescribed_clozapine: false,
            is_with_sch: false,
            is_with_park: false,
            is_chemo_or_observation: false,
            is_under_monitoring: false,
            is_with_bone_disease: false,
            is_in_patient: false,
            previous_anti_psychotics: null,
            ward_name: null,
            suspension: false,
        },
        dispensing: {
            id: null,
            permitted: false,
            has_schedule: false,
            has_treatment_break: false,
            treatment_break_date: null,
            updated_at: null,
            timeLine: [
                {
                    id: null,
                    patient_id: null,
                    memo_type: 'dispensing_stages',
                    created_by_id: null,
                    action: 'Dispensing Permitted',
                    memo_date: new Date(),
                    memo_text: 'New Patient Permitted',
                    additional_data: { type: null },
                    created_at: new Date(),
                    updated_at: new Date(),
                },
            ],
        },
        dms_id: null,
    },
    dispensingForm: {
        dispensing_permitted: false,
        dispensing_permitted_reason: null,
        blood_result_date: null,
        reason: null,
        schedule_type: null,
        frequency: null,
        input_date: null,
        schedule_restart_period: null,
        event_date: moment().format('YYYY-MM-DD'),
        dispensing_stopped: false,
        dispensing_stopped_reason: null,
        accumulated_dispensing_days: null,
        max_allowed_dispensing_days: null,
    },
};
const Patients = {
    namespaced: true,
    state: {
        tab: 0,
        // errorsInTabs: {
        //     0: [],
        //     1: [],
        //     2: [],
        //     3: [],
        //     4: [],
        //     5: [],
        // },
        patient: initialPatientsState.patient,
        patientSnapShot: initialPatientsState.patient,
        dispensingForm: initialPatientsState.dispensingForm,
        errorMessages: {
            patient: {
                id: [],
                surname: [],
                forename: [],
                birth_date: [],
                gender: [],
                race: [],
                address: [],
                nhs_id: [],
                post_code: [],
                second_address: [],
                country: [],
                county: [],
                is_registered: [],
                town: [],
                pharmacy_site_id: [],
                consultant_id: [],
                collection_centre_id: [],
                status: [],
                dont_send_mails: [],
                health_information: {
                    cnrd_date: [],
                    up_to_including_date: [],
                    normal_blood_sample_day: [],
                    tablet_qty25: [],
                    tablet_qty50: [],
                    tablet_qty100: [],
                    tablet_qty200: [],
                    suspension_amount: [],
                    is_checked: [],
                    cnrd_entry_found: [],
                    is_locked: [],
                    is_with_ben: [],
                    past_history_of_neutropenia: [],
                },
                diagnosis: {
                    diagnosis: [],
                    is_prescribed_clozapine: [],
                    is_with_sch: [],
                    is_with_park: [],
                    is_chemo_or_observation: [],
                    is_under_monitoring: [],
                    is_with_bone_disease: [],
                    is_in_patient: [],
                    previous_anti_psychotics: [],
                    ward_name: [],
                    suspension: [],
                },
                dispensing: {},
            },
            bloodResult: {
                id: [],
                date_taken: [],
                date_received: [],
                blood_result_provider_id: [],
                sample_ref: [],
                platelets: [],
                neutrophils: [],
                white_blood_count: [],
                memo: [],
                notification_to: [],
            },
            dispensingForm: {
                dispensing_permitted: [],
                dispensing_permitted_reason: [],
                blood_result_date: [],
                reason: [],
                schedule_type: [],
                frequency: [],
                input_date: [],
                schedule_restart_period: [],
                event_date: [],
                dispensing_stopped: [],
                dispensing_stopped_reason: [],
                accumulated_dispensing_days: [],
                max_allowed_dispensing_days: [],
            },
        },
        pharmaciesOptions: [],
        consultantsOptions: [],
        patientStatusOptions: [],
        townsOptions: [],
        bloodProvidersOptions: [],
        collectionCentresOptions: [],
        bloodResultPatientOptions: [],
        dispensingScheduleOptions: [],
        hasPharmacySite: false,
        bloodResult: {
            id: null,
            date_taken: null,
            date_received: null,
            blood_result_provider_id: null,
            sample_ref: null,
            platelets: null,
            neutrophils: null,
            white_blood_count: null,
            memo: null,
            notification_to: null,
        },
        updatedProps: [],
        dispensingLoading: true,
        related_record_id: null,
    },
    mutations: {
        SET_TAB(state, data) {
            state.tab = data;
        },
        SET_RELATED_RECORD_ID(state, related_record_id) {
            state.related_record_id = related_record_id;
        },
        // SET_TABS_VALIDITY(state, data) {
        //     if (!data.prop.valid && !state.errorsInTabs[data.tab].find((x) => x == data.prop.props)) {
        //         state.errorsInTabs[data.tab].push(data.prop.props);
        //     }
        //     if (data.prop.valid && state.errorsInTabs[data.tab].find((x) => x == data.prop.props)) {
        //         const errors = _.cloneDeep(state.errorsInTabs[data.tab].filter((x) => x !== data.prop.props));
        //         state.errorsInTabs[data.tab] = errors;
        //     }
        // },
        SET_PATIENT_PROPERTY(state, data) {
            _.set(state, data.property, data.value);
            // state.patient[data.property] = data.value;
        },
        RESET_PATIENT_PROPERTY_ERROR(state, data) {
            _.set(state.errorMessages, data.property, data.value);
        },
        SET_PATIENT(state, data) {
            state.patient = data;
        },
        SET_PATIENT_SNAP_SHOT(state, data) {
            state.patientSnapShot = data;
        },
        SET_PHARMACIES_OPTIONS(state, data) {
            state.pharmaciesOptions = data;
        },
        SET_CONSULTANT_OPTIONS(state, data) {
            state.consultantsOptions = data;
        },
        SET_TOWNS_OPTIONS(state, data) {
            state.townsOptions = data;
        },
        SET_BLOOD_PROVIDERS_OPTIONS(state, data) {
            state.bloodProvidersOptions = data;
        },

        ADD_BLOOD_PROVIDERS_OPTIONS(state, data) {
            if (data) {
                const providerExistinList = !!state.bloodProvidersOptions.find((x) => x.id === data.id);
                if (!providerExistinList) {
                    data.disabled = true;
                    state.bloodProvidersOptions.push(data);
                }
            }
        },
        SET_BLOOD_RESULT_PATIENTS_OPTIONS(state, data) {
            state.bloodResultPatientOptions = data;
        },
        SET_COLLECTION_CENTRE_OPTIONS(state, data) {
            state.collectionCentresOptions = data;
        },
        SET_BLOOD_RESULT(state, data) {
            state.bloodResult = data;
        },
        SET_HAS_PHARMACY_SITE(state, data) {
            state.hasPharmacySite = data;
        },
        SET_PATIENTS_STATUS_OPTIONS(state, data) {
            state.patientStatusOptions = data;
        },
        SET_DISPENSING_SCHEDULE_OPTIONS(state, data) {
            state.dispensingScheduleOptions = data;
        },
        SET_DISPENSING_LOADING(state, loading) {
            const stateLoading = _.clone(state.dispensingLoading);
            if (stateLoading !== loading) {
                state.dispensingLoading = loading;
            }
        },
        SET_ERROR_MESSAGE(state, data) {
            _.set(state.errorMessages, data.property, data.value);
            // state.errorMessages[data.property] = data.value;
            // _.set(state, data.property, data.value);
        },
        SET_UPDATED_PROPS(state, props) {
            state.updatedProps = props;
        },
        ADD_TIMELINE_ITEM_START(state, item) {
            const items = _.clone(state.patient.dispensing.timeLine);

            //FIX https://sentry.io/organizations/bgo-software/issues/3359165305/
            if (items === undefined) {
                return;
            }

            items.splice(0, 0, _.clone(item));
            _.set(state.patient.dispensing, 'timeLine', items);
        },
        ADD_TIMELINE_ITEM_AFTER_CURRENT(state, item) {
            const items = _.clone(state.patient.dispensing.timeLine);

            //FIX https://sentry.io/organizations/bgo-software/issues/3359165305/
            if (items === undefined) {
                return;
            }

            const current = items.findIndex((x) => x.timeline_position === 'current') + 1 || 0;
            items.splice(current, 0, _.clone(item));
            _.set(state.patient.dispensing, 'timeLine', items);
        },
        ADD_TIMELINE_ITEM_CURRENT(state, item) {
            let current = 0;
            const items = _.clone(state.patient.dispensing.timeLine);

            //FIX https://sentry.io/organizations/bgo-software/issues/3354582850/
            if (items === undefined) {
                return;
            }

            if (items) {
                current = items.findIndex((x) => x.timeline_position === 'current') || 0;
            }

            items.splice(current, 0, _.clone(item));
            _.set(state.patient.dispensing, 'timeLine', items);
        },
        ADD_TIMELINE_ITEM_END(state, item) {
            const items = _.clone(state.patient.dispensing.timeLine);
            items.push(_.clone(item));
            _.set(state.patient.dispensing, 'timeLine', items);
        },
        RESET_PATIENT_FORM(state) {
            state.patient = {
                id: null,
                surname: null,
                forename: null,
                birth_date: null,
                gender: null,
                race: null,
                address: null,
                post_code: null,
                second_address: null,
                country: null,
                county: null,
                is_registered: false,
                town: null,
                pharmacy_site_id: null,
                consultant_id: null,
                collection_centre_id: null,
                first_blood_sample_date: null,
                last_blood_sample_date: null,
                next_due_date: null,
                blood_testing_frequency: null,
                status: false,
                dont_send_mails: false,
                health_information: {
                    cnrd_date: null,
                    up_to_including_date: null,
                    normal_blood_sample_day: null,
                    is_checked: false,
                    cnrd_entry_found: false,
                    is_locked: false,
                    is_with_ben: false,
                    past_history_of_neutropenia: false,
                },
                diagnosis: {
                    diagnosis: null,
                    is_prescribed_clozapine: false,
                    is_with_sch: false,
                    is_with_park: false,
                    is_chemo_or_observation: false,
                    is_under_monitoring: false,
                    is_with_bone_disease: false,
                    is_in_patient: false,
                    previous_anti_psychotics: null,
                    ward_name: null,
                    suspension: false,
                },
            };
        },
        RESET_DISPENSING_FORM(state) {
            state.dispensingForm = {
                dispensing_permitted: false,
                dispensing_permitted_reason: null,
                blood_result_date: null,
                reason: null,
                schedule_type: null,
                frequency: null,
                input_date: null,
                schedule_restart_period: null,
                event_date: moment().format('YYYY-MM-DD'),
                dispensing_stopped: false,
                dispensing_stopped_reason: null,
                accumulated_dispensing_days: null,
                max_allowed_dispensing_days: null,
            };
        },
        RESET_ERROR_MESSAGES(state) {
            state.errorMessages = {
                patient: {
                    id: [],
                    surname: [],
                    forename: [],
                    birth_date: [],
                    gender: [],
                    race: [],
                    address: [],
                    nhs_id: [],
                    post_code: [],
                    second_address: [],
                    country: [],
                    county: [],
                    is_registered: [],
                    town: [],
                    pharmacy_site_id: [],
                    consultant_id: [],
                    collection_centre_id: [],
                    status: [],
                    dont_send_mails: [],
                    health_information: {
                        cnrd_date: [],
                        up_to_including_date: [],
                        normal_blood_sample_day: [],
                        tablet_qty25: [],
                        tablet_qty50: [],
                        tablet_qty100: [],
                        tablet_qty200: [],
                        suspension_amount: [],
                        is_checked: [],
                        cnrd_entry_found: [],
                        is_locked: [],
                        is_with_ben: [],
                        past_history_of_neutropenia: [],
                    },
                    diagnosis: {
                        diagnosis: [],
                        is_prescribed_clozapine: [],
                        is_with_sch: [],
                        is_with_park: [],
                        is_chemo_or_observation: [],
                        is_under_monitoring: [],
                        is_with_bone_disease: [],
                        is_in_patient: [],
                        previous_anti_psychotics: [],
                        ward_name: [],
                        suspension: [],
                    },
                    dispensing: {},
                },
                dms_id: null,
                bloodResult: {
                    id: [],
                    date_taken: [],
                    date_received: [],
                    blood_result_provider_id: [],
                    sample_ref: [],
                    platelets: [],
                    neutrophils: [],
                    white_blood_count: [],
                    memo: [],
                    notification_to: [],
                },
                dispensingForm: {
                    dispensing_permitted: [],
                    dispensing_permitted_reason: [],
                    blood_result_date: [],
                    reason: [],
                    schedule_type: [],
                    frequency: [],
                    input_date: [],
                    schedule_restart_period: [],
                    event_date: [],
                    dispensing_stopped: [],
                    dispensing_stopped_reason: [],
                    accumulated_dispensing_days: [],
                    max_allowed_dispensing_days: [],
                },
            };
        },
    },
    actions: {
        // updateErrorsInTabs({ commit }, props) {
        //     commit('SET_TABS_VALIDITY', props);
        // },
        switchToMemoTab({ commit }, related_record_id) {
            commit('SET_TAB', 5);
            commit('SET_RELATED_RECORD_ID', related_record_id);
        },
        changeTab({ commit }, tabIndex) {
            commit('SET_TAB', tabIndex);
            commit('SET_RELATED_RECORD_ID', null);
        },
        updateProperty({ commit }, data) {
            switch (data.property) {
                case 'patient.county':
                    commit('SET_PATIENT_PROPERTY', { property: 'patient.region', value: data.value });
                    break;
                default:
                    break;
            }
            commit('SET_PATIENT_PROPERTY', data);
        },
        loadPharmacyOptions({ commit }) {
            axios
                .get(
                    route('api.v1.pharmacy-sites.options', {
                        sort: 'name',
                        // is_registered: 1,
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const data = response.data.data;
                    commit('SET_PHARMACIES_OPTIONS', data);
                });
        },
        loadConsultantOptions({ commit }) {
            axios
                .get(
                    route('api.v1.consultants.options', {
                        sort: 'name',
                        is_registered: 1,
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const data = response.data.data;

                    commit('SET_CONSULTANT_OPTIONS', data);
                });
        },
        loadTownsOptions({ commit }) {
            axios.get(route('api.v1.locations.towns.options')).then((response) => {
                if (!response) {
                    return;
                }
                const data = response.data.data;

                commit('SET_TOWNS_OPTIONS', data);
            });
        },
        setBloodProvidersOptions({ commit }, data) {
            commit('SET_BLOOD_PROVIDERS_OPTIONS', data);
        },
        addBloodProvidersOptions({ commit }, data) {
            commit('ADD_BLOOD_PROVIDERS_OPTIONS', data);
        },
        loadBloodProvidersOptions({ commit }, meta = null) {
            if (meta && meta.filtered_options) {
                return axios
                    .get(
                        route('api.v1.providers.options', {
                            sort: meta.sort,
                            is_registered: meta.is_registered,
                            filtered_options: meta.filtered_options,
                        })
                    )
                    .then((response) => {
                        if (!response) {
                            return;
                        }
                        const data = response.data.data;
                        commit('SET_BLOOD_PROVIDERS_OPTIONS', data);
                    });
            }
            if (meta && meta.type) {
                return axios
                    .get(
                        route('api.v1.providers.options', {
                            sort: meta.sort,
                            is_registered: meta.is_registered,
                            type: meta.type,
                        })
                    )
                    .then((response) => {
                        if (!response) {
                            return;
                        }
                        const data = response.data.data;
                        commit('SET_BLOOD_PROVIDERS_OPTIONS', data);
                    });
            }
            if (meta && meta.indclude) {
                return axios
                    .get(
                        route('api.v1.providers.options', {
                            sort: 'name',
                            type: 'lab,cc',
                        })
                    )
                    .then((response) => {
                        if (!response) {
                            return;
                        }
                        const data = response.data.data;
                        const registeredData = data.filter((x) => x.is_registered);
                        const disabledItems = data.filter((x) => x.id === meta.indclude);
                        const mergedData = _.concat(registeredData, disabledItems);
                        const filteredData = _.clone(mergedData).map((x) => {
                            return {
                                ...x,
                                disabled: !x.is_registered,
                            };
                        });
                        commit('SET_BLOOD_PROVIDERS_OPTIONS', filteredData);
                    });
            }
            axios
                .get(
                    route('api.v1.providers.options', {
                        sort: 'name',
                        is_registered: 1,
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const data = response.data.data;

                    commit('SET_BLOOD_PROVIDERS_OPTIONS', data);
                });
        },
        loadCCOptions({ commit }) {
            return axios
                .get(
                    route('api.v1.collection-centres.options', {
                        sort: 'name',
                        is_registered: 1,
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const data = response.data.data;
                    commit('SET_COLLECTION_CENTRE_OPTIONS', data);
                });
        },
        loadBloodResultsPatientOptions({ commit }, options) {
            axios
                .get(
                    route('api.v1.patients.options', {
                        sort: 'name',
                        name: options.name ? options.name : null,
                        pharmacy_site: options.pharmacy_site_id ? options.pharmacy_site_id : null,
                        is_registered: 1,
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const data = response.data.data;
                    commit('SET_BLOOD_RESULT_PATIENTS_OPTIONS', data);
                });
        },
        loadPatientStatusOptions({ commit }) {
            axios.get(route('api.v1.patients.config')).then((response) => {
                if (!response) {
                    return;
                }
                const data = response.data.statuses;
                commit('SET_PATIENTS_STATUS_OPTIONS', data);
            });
        },
        loadDispensingScheduleOptions({ commit }) {
            axios.get(route('api.v1.dispensing.config')).then((response) => {
                if (!response) {
                    return;
                }
                const data = response.data.restart_period_options;
                commit('SET_DISPENSING_SCHEDULE_OPTIONS', data);
            });
        },
        setDispensingLoading({ commit }, loading) {
            commit('SET_DISPENSING_LOADING', loading);
        },
        clearBloodResultsPatientOptions({ commit }) {
            commit('SET_BLOOD_RESULT_PATIENTS_OPTIONS', []);
        },
        loadAddress({ commit, state }) {
            commit('SET_PATIENT_PROPERTY', { property: 'patient.county', value: state.patient.region });
        },
        reloadPatientData({ state, dispatch }, patient = false) {
            return axios
                .get(
                    route('api.v1.patients.show', {
                        patient: patient || state.patient.id,
                        fields: [
                            '*',
                            'dispensing',
                            'has_treatment_break',
                            'diagnosis.*',
                            'health_information.*',
                            'color',
                            'banner_color',
                            'validity_date',
                            'name',
                            'first_blood_sample_date',
                            'last_blood_sample_date',
                            'last_blood_sample_color',
                            'next_due_date',
                            'blood_testing_frequency',
                            'prohibited',
                            'max_dispensing',
                            'overdue',
                        ].join(','),
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const data = response.data.data;
                    dispatch('loadPatient', data);
                    dispatch('loadAddress');
                    dispatch('loadDispensingSummary');
                });
        },
        loadPatient({ commit }, data) {
            commit('SET_PATIENT', data);
            // for (let property of Object.keys(data)) {
            //     commit('SET_PATIENT_PROPERTY', { property, value: data[property] });
            // }
        },
        loadPatientDispensingTimeline({ commit }, value) {
            commit('SET_PATIENT_PROPERTY', { property: 'patient.dispensing.timeLine', value });
        },
        loadTimeline({ commit, state }) {
            if (!state.patient && !state.patient.id) {
                return;
            }
            commit('SET_DISPENSING_LOADING', true);
            return axios
                .get(
                    route('api.v1.patients.dispensing.timeline', {
                        patient: state.patient.id,
                        fields: '*,created_by.name',
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const value = _.cloneDeep(response.data.data);
                    const can = !state.patient.dispensing.permitted;
                    if (state.patient.dispensing.timeLine) {
                        const hasPermittedItem = !state.patient.dispensing.timeLine.find(
                            (x) => x.additional_data.type === 'dispensing-start' && x.id === 'new'
                        );
                        if (can && hasPermittedItem) {
                            const item = initialPatientsState.patient.dispensing.timeLine[0];
                            item.id = 'new';
                            item.additional_data.type = 'dispensing-start';
                            item.timeline_position = 'current';
                            value.splice(0, 0, _.cloneDeep(item));
                        }
                    }
                    commit('SET_PATIENT_PROPERTY', { property: 'patient.dispensing.timeLine', value });
                })
                .finally(() => {
                    _.delay(() => commit('SET_DISPENSING_LOADING', false), 300, 'later');
                });
        },
        loadDispensingSummary({ commit, state, dispatch }) {
            if (!state.patient && !state.patient.id) {
                return;
            }
            return axios
                .get(
                    route('api.v1.patients.show', {
                        patient: state.patient.id,
                        fields: 'dispensing,status,is_registered,has_treatment_break,is_allowed_to_dispense,banner_color,prohibited,blood_testing_frequency,validity_date,overdue',
                    })
                )
                .then((response) => {
                    if (!response) {
                        return;
                    }
                    const patientData = _.cloneDeep(response.data.data);
                    const data = _.cloneDeep(response.data.data.dispensing);
                    delete data.timeLine;
                    data.timeLine = [];
                    commit('SET_PATIENT_PROPERTY', { property: 'patient.dispensing', value: data });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.is_allowed_to_dispense',
                        value: patientData.is_allowed_to_dispense,
                    });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.status',
                        value: patientData.status,
                    });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.is_registered',
                        value: patientData.is_registered,
                    });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.banner_color',
                        value: patientData.banner_color,
                    });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.prohibited',
                        value: patientData.prohibited,
                    });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.blood_testing_frequency',
                        value: patientData.blood_testing_frequency,
                    });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.validity_date',
                        value: patientData.validity_date,
                    });
                    commit('SET_PATIENT_PROPERTY', {
                        property: 'patient.overdue',
                        value: patientData.overdue,
                    });
                    dispatch('loadTimeline');
                });
        },
        addPatientDispensingTimelineItem({ commit }, data) {
            switch (data.on) {
                case 'start':
                    commit('ADD_TIMELINE_ITEM_START', data.item);
                    break;
                case 'current':
                    commit('ADD_TIMELINE_ITEM_CURRENT', data.item);
                    break;
                case 'after-current':
                    commit('ADD_TIMELINE_ITEM_AFTER_CURRENT', data.item);
                    break;
                case 'end':
                    commit('ADD_TIMELINE_ITEM_END', data.item);
                    break;
                default:
                    break;
            }
        },
        addPatientDispensingTimelineItemFillAe({ state, dispatch }) {
            const timeLine = state.patient.dispensing.timeLine;
            let hasAdverseEvent = null;

            if (timeLine) {
                hasAdverseEvent = timeLine.find((x) => x.additional_data.type === 'fill-adverse-event');
            }

            if (!hasAdverseEvent) {
                const adverseEvent = {
                    id: 'new',
                    patient_id: null,
                    memo_type: null,
                    created_by_id: null,
                    action: null,
                    memo_date: new Date(),
                    memo_text: null,
                    additional_data: { type: 'fill-adverse-event' },
                    timeline_position: 'current',
                    created_at: new Date(),
                    updated_at: new Date(),
                };
                dispatch('addPatientDispensingTimelineItem', {
                    on: state.patient.dispensing.permitted ? 'current' : 'after-current',
                    item: _.clone(adverseEvent),
                });
            }
        },
        removePatientDispensingTimelineItem({ commit }, item) {
            console.warn({ commit, item });
        },

        loadPatientSnapShot({ commit }, data) {
            commit('SET_PATIENT_SNAP_SHOT', data);
            // for (let property of Object.keys(data)) {
            //     commit('SET_PATIENT_PROPERTY', { property, value: data[property] });
            // }
        },
        loadBloodResult({ commit }, data) {
            if (data && data.blood_result_provider && data.blood_result_provider.id) {
                data.blood_result_provider_id = data.blood_result_provider.id;
            }
            commit('SET_BLOOD_RESULT', data);
        },
        newBloodResult({ commit, state }) {
            commit('SET_BLOOD_RESULT', {
                id: null,
            });
            if (state.tab !== 4) {
                commit('SET_TAB', 4);
            }
            if (state.tab === 4) {
                _.delay(() => {
                    commit('SET_BLOOD_RESULT', {
                        id: 'new',
                        date_taken: null,
                        date_received: null,
                        blood_result_provider_id: null,
                        sample_ref: null,
                        platelets: null,
                        neutrophils: null,
                        white_blood_count: null,
                        memo: null,
                        notification_to: null,
                    });
                }, 300);
            }
        },
        setPharmacySite({ commit }, data) {
            commit('SET_HAS_PHARMACY_SITE', true);
            commit('SET_PATIENT_PROPERTY', { property: 'patient.pharmacy_site_id', value: data.value });
        },
        resetPropertyError({ commit }, data) {
            commit('RESET_PATIENT_PROPERTY_ERROR', data);
        },
        setUpdatedProps({ commit }, props) {
            commit('SET_UPDATED_PROPS', props);
        },
        resetDispensingForm({ commit, dispatch }, patient) {
            commit('RESET_DISPENSING_FORM');
            dispatch('reloadPatientData', patient);
        },
        resetPatientForm({ commit }) {
            commit('RESET_PATIENT_FORM');
        },
        resetErrorMessages({ commit }) {
            commit('RESET_ERROR_MESSAGES');
            // _.each(state.errorMessages, function (messages, field) {
            //     const vueObjectToPlain = JSON.parse(JSON.stringify(state.errorMessages[field]));
            //     if (_.isPlainObject(vueObjectToPlain)) {
            //         _.each(state.errorMessages[field], function (messages, plainObjectField) {
            //             commit('SET_ERROR_MESSAGE', { value: [], property: `${field}.${plainObjectField}` });
            //         });
            //     } else {
            //         commit('SET_ERROR_MESSAGE', { value: [], property: field });
            //     }
            // });
        },
        setErrorMessages({ commit, state }, data) {
            const errors = data.isBloodResults || data.isDispensingForm ? data.errors : data;
            let propertyToAdd = 'patient';
            propertyToAdd = data.isBloodResults ? 'bloodResult' : propertyToAdd;
            propertyToAdd = data.isDispensingForm ? 'dispensingForm' : propertyToAdd;

            _.each(errors, function (fieldErrors) {
                const errorMessageField = _.get(state.errorMessages, `${propertyToAdd}.${fieldErrors.field}`);

                if (fieldErrors.field && errorMessageField !== undefined) {
                    if (fieldErrors.field === 'diagnosis') {
                        fieldErrors.field = 'diagnosis.diagnosis';
                    }
                    commit('SET_ERROR_MESSAGE', {
                        value: fieldErrors.errors,
                        property: `${propertyToAdd}.${fieldErrors.field}`,
                    });
                }
            });
        },
    },
};

export default Patients;
